import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EventsService from "../services/EventsService";

function JoinEventPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState(null);
  const [joining, setJoining] = useState(false);

  const handleJoin = async () => {
    if (!displayName.trim()) { setError("Enter your display name."); return; }
    setError(null);
    setJoining(true);
    try {
      const result = await EventsService.joinSharedEvent(code, displayName.trim());
      navigate(`/shared-event/${result.sharedEventId || result.id}`);
    } catch (err) {
      setError(err?.message || "Failed to join event. Invalid code or event not found.");
      setJoining(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #0a0a16, #141430)",
    }}>
      <div style={{
        background: "rgba(18,18,32,0.97)", backdropFilter: "blur(20px)",
        border: "0.5px solid rgba(255,255,255,0.12)", borderRadius: 24,
        padding: 32, width: "90%", maxWidth: 420, textAlign: "center",
      }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}><i className="fas fa-users" style={{ color: "#0A84FF" }}></i></div>
        <h2 style={{ color: "#fff", fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Join Event</h2>
        <div style={{
          fontSize: 28, fontWeight: 800, color: "#0A84FF", letterSpacing: "0.2em",
          fontFamily: "monospace", marginBottom: 24,
        }}>{code?.toUpperCase()}</div>

        <label style={{ display: "block", textAlign: "left", color: "rgba(255,255,255,0.5)", fontSize: 12, fontWeight: 600, marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.06em" }}>
          Your Display Name
        </label>
        <input
          type="text"
          className="form-control create-event-name-input"
          placeholder="e.g. John, Team A..."
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          autoFocus
          style={{ marginBottom: 20, textAlign: "center" }}
          onKeyDown={(e) => { if (e.key === "Enter") handleJoin(); }}
        />
        {error && <p style={{ color: "#FF453A", fontSize: 13, marginBottom: 12 }}>{error}</p>}
        <button
          onClick={handleJoin}
          disabled={joining}
          style={{
            background: "linear-gradient(135deg, #0A84FF, #0066CC)",
            color: "#fff", border: "none", borderRadius: 14,
            padding: "14px 0", fontWeight: 700, fontSize: 16,
            cursor: "pointer", width: "100%",
          }}
        >
          {joining ? "Joining..." : "Join Event"}
        </button>
      </div>
    </div>
  );
}

export default JoinEventPage;
